// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mTournamentEditPlayersFormWidth {
  max-width: 1020px !important;
  width: min(1020px, calc(100vw - 32px)) !important;
}

.tournamentManageEventsModal {
  overflow: hidden;
  border-radius: 14px !important;
}

.tournamentManageEventsModal__body {
  padding: 0 !important;
}

.ttm-page .ttm-edit-btn {
  width: 28px;
  height: 28px;
  border: 1px solid #d8e2ec;
  border-radius: 6px;
  background: #fff;
  color: #5b6b7a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s ease;
  padding: 0;
}

.ttm-page .ttm-edit-btn:hover {
  background: #f4f8fc;
  border-color: #b8cde3;
  color: #2f80ed;
}

.ttm-page .ttm-edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(47, 128, 237, 0.15);
}

.ttm-page table {
  table-layout: fixed;
  width: 100%;
}

.ttm-page th,
.ttm-page td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ttm-page th:last-child,
.ttm-page td:last-child {
  width: 52px;
  min-width: 52px;
  max-width: 52px;
  text-align: center;
}

.ttm-page th:nth-child(1),
.ttm-page td:nth-child(1) {
  width: 26%;
}

.ttm-page th:nth-child(2),
.ttm-page td:nth-child(2) {
  width: 24%;
}

.ttm-page th:nth-child(3),
.ttm-page td:nth-child(3) {
  width: 20%;
}

.ttm-page th:nth-child(4),
.ttm-page td:nth-child(4) {
  width: 18%;
}

.ttm-page th:nth-child(5),
.ttm-page td:nth-child(5) {
  width: 12%;
}

.tournamentTeamConflictModal .modal-body {
  padding: 0;
}

.tournamentTeamConflictModal__body {
  padding: 20px 22px;
}

.tournamentTeamConflictModal__intro {
  margin: 0 0 16px;
  color: var(--text-muted, #69778a);
  font-size: 13px;
  line-height: 1.5;
}

.tournamentTeamConflictModal__list {
  display: grid;
  gap: 10px;
}

.tournamentTeamConflictModal__row {
  padding: 13px 14px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--surface-subtle, #f8fafc);
}

.tournamentTeamConflictModal__row > strong {
  display: block;
  margin-bottom: 9px;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
}

.tournamentTeamConflictModal__choices {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.tournamentTeamConflictModal__choices label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 9px 10px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12px;
  cursor: pointer;
}

.tournamentTeamConflictModal__choices label:has(input:checked) {
  border-color: var(--blue-500, #3298cc);
  background: var(--blue-50, #eef8fc);
}

.tournamentTeamConflictModal__choices input {
  accent-color: var(--blue-600, #227ebd);
}

.tournamentTeamConflictModal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
}

.tournamentTeamConflictModal__actions button {
  height: 36px;
  padding: 0 15px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentTeamConflictModal__actions button:last-child {
  border-color: var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

@media (max-width: 640px) {
  .tournamentTeamConflictModal__choices {
    grid-template-columns: 1fr;
  }
}

.tournamentEventsModern,
.tournamentTeamsModern,
.tournamentTeamPlayersModern,
.tournamentInvitesManagePage {
  min-width: 0;
  padding: 20px 12px 28px;
  background: #f7f8fa;
}

.tournamentInvitesManagePage > .row,
.tournamentInvitesManagePage > .row > [class*='col-'] {
  margin: 0;
  padding: 0;
}

.tournamentTeamPlayersModern {
  min-height: calc(100vh - 76px);
  margin-top: -20px;
  padding: 0 12px 28px;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.tournamentTeamPlayersModern__header,
.tournamentTeamPlayersModern__card,
.tournamentTeamPlayersModern__footer,
.tournamentTeamPlayersModern__error {
  width: 100%;
}

.tournamentTeamPlayersModern__header {
  box-sizing: border-box;
  width: auto;
  margin: 0 -36px 18px;
  padding: 15px 28px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.tournamentTeamPlayersModern__back {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  padding: 0 8px;
  border-radius: 8px;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentTeamPlayersModern__back:hover {
  background: var(--blue-50, #eef6fc);
}

.tournamentTeamPlayersModern__headingRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.tournamentTeamPlayersModern__eyebrow {
  display: block;
  margin-bottom: 3px;
  color: var(--blue-700, #155d8c);
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.tournamentTeamPlayersModern__headingRow h1 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 850;
  line-height: 1.2;
}

.tournamentTeamPlayersModern__headingRow p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}

.tournamentTeamPlayersModern__summary {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 0 1 auto;
}

.tournamentTeamPlayersModern__summary span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  font-weight: 650;
}

.tournamentTeamPlayersModern__identity {
  min-width: 0;
  flex: 1 1 480px;
}

.tournamentTeamPlayersModern__contextTitle {
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 550;
  line-height: 1.35;
}

.tournamentTeamPlayersModern__contextTitle strong {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 14px;
  font-weight: 750;
}

.tournamentTeamPlayersModern__teamDetails {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.tournamentTeamPlayersModern__teamDetails > img,
.tournamentTeamPlayersModern__schoolInitial {
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 17px;
  font-weight: 800;
  object-fit: contain;
}

.tournamentTeamPlayersModern__teamDetails > div,
.tournamentTeamPlayersModern__teamDetails strong,
.tournamentTeamPlayersModern__teamDetails div > span {
  display: block;
}

.tournamentTeamPlayersModern__teamDetails strong {
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 750;
}

.tournamentTeamPlayersModern__teamDetails div > span {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.tournamentTeamPlayersModern__summary span.is-available {
  border-color: #cde8d7;
  background: #edf8f1;
  color: #287a50;
}

.tournamentTeamPlayersModern__summary span.is-available strong {
  color: inherit;
}

.tournamentTeamPlayersModern__summary strong {
  color: var(--text-strong, #142033);
}

.tournamentTeamPlayersModern__summary span.is-over-limit {
  border-color: var(--red-300, #fca5a5);
  background: var(--red-50, #fff1f2);
  color: var(--red-700, #b42318);
}

.tournamentTeamPlayersModern__summary span.is-over-limit strong {
  color: var(--red-800, #991b1b);
}

.tournamentTeamPlayersModern__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 12px 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 0;
  background: transparent;
}

.tournamentTeamPlayersModern__toolbarActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.tournamentTeamPlayersModern__toolbarActions button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.tournamentTeamPlayersModern__toolbarActions button:hover {
  border-color: var(--blue-400, #55a8d5);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.tournamentTeamPlayersModern__toolbarActions button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.tournamentPlayerNumberModal .modal-body {
  padding: 0;
}

.tournamentPlayerNumberForm {
  padding: 2px 20px 18px;
}

.tournamentPlayerNumberForm__person {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 10px;
  border-radius: 10px;
  background: var(--surface-sunken, #f1f5f9);
}

.tournamentPlayerNumberForm__person > span {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-weight: 800;
  text-transform: uppercase;
}

.tournamentPlayerNumberForm__person strong,
.tournamentPlayerNumberForm__person small {
  display: block;
}

.tournamentPlayerNumberForm__person strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
}

.tournamentPlayerNumberForm__person small {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}

.tournamentPlayerNumberForm > label > span {
  display: block;
  margin-bottom: 6px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 750;
}

.tournamentPlayerNumberForm > label input {
  width: 140px;
  height: 38px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: 0;
  font-size: 13px;
}

.tournamentPlayerNumberForm > label input:focus {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}

.tournamentPlayerNumberForm > label > small {
  display: block;
  margin-top: 6px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  line-height: 1.4;
}

.tournamentPlayerNumberForm__error {
  margin-top: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 12px;
}

.tournamentPlayerNumberForm footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.tournamentPlayerNumberForm footer button {
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentPlayerNumberForm footer .is-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.tournamentTeamNumbersModal .modal-body {
  padding: 0;
}
.tournamentTeamNumbersForm {
  padding: 2px 20px 18px;
}
.tournamentTeamNumbersForm > p {
  margin: 0 0 16px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  line-height: 1.45;
}
.tournamentTeamNumbersForm > p strong {
  color: var(--text-strong, #0f172a);
}
.tournamentTeamNumbersForm__range {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.tournamentTeamNumbersForm__range label {
  margin: 0;
}
.tournamentTeamNumbersForm__range label > span,
.tournamentTeamNumbersForm legend {
  display: block;
  margin-bottom: 6px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 750;
}
.tournamentTeamNumbersForm__range b {
  color: #dc2626;
}
.tournamentTeamNumbersForm__range input {
  width: 128px;
  height: 38px;
  padding: 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: 0;
  font-size: 13px;
}
.tournamentTeamNumbersForm__range input:focus {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}
.tournamentTeamNumbersForm fieldset {
  margin: 18px 0 0;
  padding: 0;
  border: 0;
}
.tournamentTeamNumbersForm__option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 8px;
  padding: 10px 11px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 9px;
  cursor: pointer;
}
.tournamentTeamNumbersForm__option input {
  margin-top: 3px;
  accent-color: var(--blue-500, #227ebd);
}
.tournamentTeamNumbersForm__option span,
.tournamentTeamNumbersForm__option strong,
.tournamentTeamNumbersForm__option small {
  display: block;
}
.tournamentTeamNumbersForm__option strong {
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
}
.tournamentTeamNumbersForm__option small {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}
.tournamentTeamNumbersForm__error {
  margin-top: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 12px;
}
.tournamentTeamNumbersForm footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}
.tournamentTeamNumbersForm footer button {
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  font-weight: 700;
}
.tournamentTeamNumbersForm footer .is-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.tournamentTeamPlayersModern__card {
  padding: 14px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
}

.tournamentTeamPlayersModern__cardHead {
  padding: 0 0 11px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.tournamentTeamPlayersModern__cardHead h2 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 15.5px;
  font-weight: 750;
}

.tournamentTeamPlayersModern__cardHead p {
  margin: 3px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.4;
}

.tournamentTeamPlayersModern__editor {
  min-width: 0;
  padding-top: 12px;
}

.tournamentTeamPlayersModern__error {
  margin-top: 12px;
  padding: 11px 13px;
  border: 1px solid #ffd5da;
  border-radius: 9px;
  background: #fff5f6;
  color: var(--red-700, #9f2430);
  font-size: 12.5px;
  font-weight: 650;
}

.tournamentTeamPlayersModern__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
}

.tournamentTeamPlayersModern__footer > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tournamentTeamPlayersModern__footer strong {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
}

.tournamentTeamPlayersModern__footer span {
  color: var(--amber-700, #9a6500);
  font-size: 11.5px;
  font-weight: 650;
}

.tournamentTeamPlayersModern__footer button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 750;
}

.tournamentTeamPlayersModern__footer button.isSecondary {
  border: 1px solid var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-body, #334155);
}

.tournamentTeamPlayersModern__footer button.isPrimary {
  min-width: 156px;
  border: 1px solid var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

.tournamentTeamPlayersModern__footer button.isPrimary:disabled {
  border-color: var(--slate-300, #cbd5e1);
  background: var(--slate-300, #cbd5e1);
  cursor: not-allowed;
}

.tournamentTeamPlayersModern__footer svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
}

.tournamentParticipantsExitModalHost {
  padding: 0 !important;
}

.tournamentParticipantsNoticeModalHost {
  padding: 0 !important;
}

.tournamentParticipantsNoticeModal {
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
}

.tournamentParticipantsNoticeModal > header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.tournamentParticipantsNoticeModal__icon {
  display: inline-flex;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  height: 34px;
  border-radius: 50%;
  background: var(--blue-500, #227ebd);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
}

.tournamentParticipantsNoticeModal.isWarning .tournamentParticipantsNoticeModal__icon {
  background: var(--amber-500, #d99a19);
}

.tournamentParticipantsNoticeModal header > div:nth-child(2) {
  flex: 1 1 auto;
}
.tournamentParticipantsNoticeModal h2 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 18px;
  font-weight: 800;
}
.tournamentParticipantsNoticeModal header p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}
.tournamentParticipantsNoticeModal header > button {
  border: 0;
  background: transparent;
  color: var(--text-muted, #69778a);
  font-size: 22px;
  line-height: 1;
}
.tournamentParticipantsNoticeModal__body {
  padding: 20px 22px;
  color: var(--text-body, #334155);
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
}
.tournamentParticipantsNoticeModal > footer {
  display: flex;
  justify-content: flex-end;
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--surface-subtle, #f8fafc);
}
.tournamentParticipantsNoticeModal footer button {
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 12.5px;
  font-weight: 750;
}

.tournamentParticipantsExitModal {
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
}

.tournamentParticipantsExitModal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.tournamentParticipantsExitModal h2 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 18px;
  font-weight: 800;
}

.tournamentParticipantsExitModal header p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}

.tournamentParticipantsExitModal header > button {
  width: 30px;
  height: 30px;
  border: 0;
  background: transparent;
  color: var(--text-muted, #69778a);
  font-size: 22px;
  line-height: 1;
}

.tournamentParticipantsExitModal__body {
  padding: 20px 22px;
  color: var(--text-body, #334155);
  font-size: 13px;
  line-height: 1.5;
}

.tournamentParticipantsExitModal > footer {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--surface-subtle, #f8fafc);
}

.tournamentParticipantsExitModal footer button {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  font-weight: 750;
}

.tournamentParticipantsExitModal footer button.isDanger {
  border-color: var(--red-600, #c4313f);
  background: var(--red-600, #c4313f);
  color: #fff;
}

@media (max-width: 760px) {
  .tournamentTeamPlayersModern__headingRow,
  .tournamentTeamPlayersModern__toolbar,
  .tournamentTeamPlayersModern__footer {
    align-items: stretch;
    flex-direction: column;
    position: sticky;
    bottom: 8px;
    z-index: 10;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14);
  }

  .tournamentTeamPlayersModern__summary,
  .tournamentTeamPlayersModern__toolbarActions,
  .tournamentTeamPlayersModern__footer > div {
    justify-content: flex-start;
  }

  .tournamentTeamPlayersModern__footer > div:last-child button {
    flex: 1 1 0;
  }
}

.tournamentTeamsModern {
  min-height: calc(100vh - 76px);
  color: #334155;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.tournamentTeamsModern > .row,
.tournamentTeamsModern > .row > [class*='col-'] {
  margin: 0;
  padding: 0;
}

.tournamentTeamsModern .gridPanelTitleRow {
  margin: 0 0 16px;
}

.tournamentTeamsModern .gridPanelTitle {
  flex-wrap: wrap;
  gap: 10px;
}

.tournamentTeamsModern .gridModernTitleBlock {
  min-width: min(100%, 280px);
  margin-right: 4px;
}

.tournamentTeamsModern .gridModernTitleBlock h1 {
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  line-height: 30px;
  font-weight: 850;
}

.tournamentTeamsModern .gridModernBack {
  margin-bottom: 2px;
}

.tournamentTeamsModern .gridModernSearch {
  width: min(260px, 100%);
  margin-left: 0;
}

.tournamentTeamsModern .gridInlineActions button {
  border-color: #cbd5e1;
  background: #fff;
  color: #334155;
}

.tournamentTeamsModern .gridInlineActions {
  margin-left: auto;
}

.tournamentTeamsModern .gridTableActions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin: 12px 0 8px;
  padding: 9px 11px;
  border: 1px solid #cfe1f2;
  border-radius: 10px;
  background: #f3f8fc;
}

.tournamentTeamsModern .gridTableActions > span {
  flex: 0 0 auto;
  color: #456b84;
  font-size: 12px;
  font-weight: 750;
}

.tournamentTeamsModern .gridTableActions > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 7px;
}

.tournamentTeamsModern .gridTableActions button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #b8cad8;
  border-radius: 8px;
  background: #fff;
  color: #27536f;
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentTeamsModern .gridTableActions button:hover {
  border-color: #7eabc7;
  background: #f8fcff;
}

.tournamentTeamsModern .gridTableActions button.is-danger {
  border-color: var(--red-500, #c4313f);
  background: var(--red-500, #c4313f);
  color: #fff;
}

.tournamentTeamsModern .gridTableActions button.is-danger:hover {
  border-color: var(--red-600, #a92734);
  background: var(--red-600, #a92734);
}

.tournamentTeamsModern .gridInlineActions button:hover {
  border-color: #8ab8d5;
  background: #f3f8fc;
  color: #176895;
}

.tournamentTeamsModern .gridInlineActions button:only-child:not(.is-danger) {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.tournamentTeamsModern .gridInlineActions button:only-child:not(.is-danger):hover {
  border-color: #196b9f;
  background: #196b9f;
}

.tournamentTeamsModern .table-responsive {
  margin-top: 0;
  overflow-x: auto;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.tournamentTeamsModern table.table {
  min-width: 680px;
  margin: 0 !important;
  table-layout: fixed;
}

.tournamentTeamsModern table thead th {
  padding: 12px 14px;
  border: 0;
  border-bottom: 1px solid #dbe3ec;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.045em;
  text-transform: uppercase;
  vertical-align: middle;
}

.tournamentTeamsModern table thead th:first-child,
.tournamentTeamsModern table tbody td:first-child {
  width: 48px;
  text-align: center;
}

.tournamentTeamsModern table tbody td {
  height: 56px;
  padding: 12px 14px;
  border: 0;
  border-bottom: 1px solid #edf1f5;
  background: #fff;
  color: #334155;
  font-size: 13px;
  line-height: 19px;
  vertical-align: middle;
}

.tournamentTeamsModern table tbody tr:last-child td {
  border-bottom: 0;
}

.tournamentTeamsModern .table-responsive table.table-hover tbody tr,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr > td,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover > td,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary > td,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary:hover,
.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary:hover > td {
  transform: none;
  box-shadow: none;
}

.tournamentTeamsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover > td {
  background: #f8fbfd;
}

.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary > td {
  background: #eef6fc !important;
}

.tournamentTeamsModern__cell--name {
  color: #172033 !important;
  font-weight: 750;
}

.tournamentTeamsModern__cell--numberOfStudents {
  color: #475569 !important;
  font-variant-numeric: tabular-nums;
}

.tournamentTeamsModern .gridModernEmptyRow:hover > td,
.tournamentTeamsModern .gridModernEmptyRow > td {
  height: 190px;
  background: #fff !important;
  text-align: center;
  cursor: default;
}

.tournamentTeamsModern .gridModernEmptyRow td > span,
.tournamentTeamsModern .gridModernEmptyRow td > strong,
.tournamentTeamsModern .gridModernEmptyRow td > small {
  display: block;
}

.tournamentTeamsModern .gridModernEmptyRow td > span {
  margin-bottom: 8px;
  color: #94a3b8;
  font-size: 26px;
}

.tournamentTeamsModern .gridModernEmptyRow td > strong {
  color: #334155;
  font-size: 14px;
}

.tournamentTeamsModern .gridModernEmptyRow td > small {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
}

.tournamentTeamsModern .gridModernPagination {
  justify-content: flex-end;
  padding-top: 14px;
}

.tournamentEventsModern .gridModernFilterPopover {
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  max-height: none;
  flex-direction: column;
  overflow: hidden;
  border: 0;
  border-left: 1px solid #dbe3ec;
  border-radius: 0;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.tournamentEventsModern .gridModernFilterPopover__fields {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
}

@media (max-width: 600px) {
  .tournamentEventsModern,
  .tournamentTeamsModern,
  .tournamentTeamPlayersModern {
    padding: 14px;
  }

  .tournamentEventsModern .gridModernFilterPopover {
    top: 0;
    left: 0;
    width: 100vw;
    max-width: none;
    height: 100vh;
  }

  .tournamentTeamsModern .gridPanelTitle {
    align-items: stretch;
  }

  .tournamentTeamsModern .gridModernTitleBlock,
  .tournamentTeamsModern .gridModernSearch,
  .tournamentTeamsModern .gridModernFiltersAnchor,
  .tournamentTeamsModern .gridModernFilterButton,
  .tournamentTeamsModern .gridModernColumns,
  .tournamentTeamsModern .gridModernColumns > button,
  .tournamentTeamsModern .gridInlineActions {
    width: 100%;
  }

  .tournamentTeamsModern .gridInlineActions {
    display: grid;
    grid-template-columns: 1fr;
  }

  .tournamentTeamsModern .gridTableActions {
    align-items: stretch;
    flex-direction: column;
  }

  .tournamentTeamsModern .gridTableActions > div {
    display: grid;
    grid-template-columns: 1fr;
  }

  .tournamentTeamsModern .gridModernFilterPopover {
    position: fixed;
    inset: 0;
    width: 100vw;
    max-width: none;
    border-radius: 0;
  }
}

.tournamentEventParticipants {
  min-width: 0;
  padding: 0;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.tournamentEventParticipants__header .bSchoolTeamManager__summaryCard {
  margin: 0;
  padding: 18px 22px 14px;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #e5e9f0);
  border-radius: 0;
  background: var(--surface-card, #fff);
  box-shadow: none;
}

.tournamentEventParticipants__title {
  margin: 0 0 4px;
  color: var(--text-strong, #0f172a);
  font-size: 17px;
  font-weight: 800;
}

.tournamentEventParticipants__header .bSchoolTeamManager__summaryTitle {
  margin-top: 3px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 500;
}

.tournamentEventParticipants__header .bSchoolTeamManager__summaryText {
  display: none;
}

.tournamentEventParticipants__header .tournamentEventParticipants__close {
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 8px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 18px;
}

.tournamentEventParticipants--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(1100px, calc(100vw - 48px));
  min-height: 560px;
  background: var(--surface-card, #fff);
}

.tournamentEventParticipants__limitWarning {
  margin: 14px 22px 0;
  padding: 12px 14px;
  color: #721c24;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-left: 5px solid #dc3545;
  border-radius: 6px;
}

.tournamentEventParticipants__limitWarning p {
  margin: 2px 0 6px;
}

.tournamentEventParticipants__editor {
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: var(--surface-card, #fff);
}

.tournamentEventParticipants__editor .twoPanelEditor__row {
  margin: 0;
}

.tournamentEventParticipants__studentName {
  display: flex;
  min-width: 150px;
  flex-direction: column;
  gap: 3px;
}

.tournamentEventParticipants__studentName small {
  max-width: 260px;
  color: #667085;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  white-space: normal;
}

.tournamentEventParticipants__footer {
  margin: 0;
  padding: 13px 22px;
  border: 0;
  border-top: 1px solid var(--border-subtle, #e5e9f0);
  border-radius: 0;
  background: var(--surface-card, #fff);
}

.tournamentEventParticipants__footer .bSchoolTeamManager__btnSecondary,
.tournamentEventParticipants__footer .bSchoolTeamManager__btnPrimary {
  min-height: 40px;
  padding: 0 18px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 750;
}

.tournamentEventsModern > .row,
.tournamentEventsModern > .row > [class*='col-'] {
  margin: 0;
  padding: 0;
}

.tournamentEventsModern .gridPanelTitleRow {
  margin: 0 0 16px;
}

.tournamentEventsModern .gridPanelTitle {
  display: grid;
  grid-template-columns: minmax(240px, 360px) auto auto 1fr;
  gap: 10px;
}

.tournamentEventsModern .gridModernTitleLine h1 {
  color: var(--text-strong, #0f172a);
  font-size: 24px;
  font-weight: 800;
}

.tournamentEventsModern .gridModernTitleBlock {
  grid-column: 1 / -1;
}

.tournamentEventsModern .gridModernSearch {
  width: min(100%, 360px);
  margin: 0;
}

.tournamentEventsModern .gridInlineActions {
  grid-column: 1 / -1;
  margin: 0;
}

.tournamentEventsModern .gridInlineActions button,
.tournamentEventsModern .gridTableActions button {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 650;
}

.tournamentEventsModern .gridInlineActions button:first-child:not(:disabled),
.tournamentEventsModern .gridTableActions button:first-child:not(:disabled) {
  border-color: var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

.tournamentEventsModern .gridTableActions {
  display: flex;
  min-height: 0;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin: 0 0 12px;
  padding: 8px 14px;
  border: 1px solid var(--blue-100, #d4e8f6);
  border-radius: 8px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.tournamentEventsModern .gridActiveFilters + .gridTableActions {
  margin-top: 10px;
}

.tournamentEventsModern .gridTableActions > span {
  flex: 0 0 auto;
  color: var(--blue-700, #155d8c);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.tournamentEventsModern .gridTableActions > div {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tournamentEventsModern .gridTableActions button {
  min-height: 32px;
  height: 32px;
  padding: 0 11px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.tournamentEventsModern .table-responsive {
  overflow-x: auto;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.tournamentEventsModern table.table {
  margin: 0 !important;
}

.tournamentEventsModern table thead th {
  border-top: 0;
  background: var(--surface-subtle, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.tournamentEventsModern table tbody td {
  padding: 12px 14px;
  border-top: 0;
  border-bottom: 1px solid #edf1f5;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 13px;
  line-height: 1.4;
  vertical-align: middle;
}

.tournamentEventsModern table tbody td a {
  font-size: 13px;
  line-height: 1.4;
}

.tournamentEventsModern .gridModernSearch input {
  font-size: 13px;
}

.tournamentEventsModern .gridModernSearch__clear {
  position: relative;
  display: inline-flex;
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 0;
  cursor: pointer;
}

.tournamentEventsModern .gridModernSearch__clear::before,
.tournamentEventsModern .gridModernSearch__clear::after {
  position: absolute;
  width: 12px;
  height: 1.5px;
  border-radius: 999px;
  background: currentColor;
  content: '';
}

.tournamentEventsModern .gridModernSearch__clear::before {
  transform: rotate(45deg);
}

.tournamentEventsModern .gridModernSearch__clear::after {
  transform: rotate(-45deg);
}

.tournamentEventsModern .gridModernSearch__clear:hover {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.tournamentEventsModern .gridModernSearch__clear:focus-visible {
  outline: 2px solid var(--blue-500, #227ebd);
  outline-offset: 1px;
}

.tournamentEventsModern .gridModernBack,
.tournamentEventsModern .gridModernFilterButton,
.tournamentEventsModern .gridModernColumns > button {
  font-size: 13px;
}

.tournamentEventParticipants,
.tournamentEventParticipants button,
.tournamentEventParticipants input,
.tournamentEventParticipants select {
  font-size: 13px;
}

.tournamentEventParticipants .twoPanelEditorPanel__personText strong {
  font-size: 13px;
}

.tournamentEventParticipants .twoPanelEditorPanel__personText small,
.tournamentEventParticipants .twoPanelEditorPanel__modernTitle span,
.tournamentEventParticipants .twoPanelEditorPanel__capacity > span {
  font-size: 11px;
}

.tournamentEventsModern__cell--generatedName {
  color: var(--blue-700, #1c5d8c) !important;
  font-weight: 650;
}

.tournamentEventsModern__cell--status {
  width: 110px;
  color: var(--green-700, #1c7a44) !important;
  font-size: 11px;
  font-weight: 700;
}

.tournamentEventsModern__status {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2f6;
  color: #536273;
  font-size: 11px;
  font-weight: 700;
}

.tournamentEventsModern__status.is-accepted,
.tournamentEventsModern__status.is-approved {
  background: #e4f5ea;
  color: #1c7a44;
}

.tournamentEventsModern__status.is-pending,
.tournamentEventsModern__status.is-not-ready {
  background: #fdf1dc;
  color: #a86b08;
}

.tournamentEventsModern__athletes span,
.tournamentEventsModern__athletes small {
  display: block;
}

.tournamentEventsModern__athletes span {
  overflow: hidden;
  color: var(--text-body, #334155);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tournamentEventsModern__athletes small {
  margin-top: 3px;
  color: var(--text-muted, #69778a);
  font-size: 11px;
}

.tournamentEventsModern__athletes > i {
  display: block;
  width: 64px;
  height: 4px;
  margin-top: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf1f5;
}

.tournamentEventsModern__athletes > i > b {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--green-500, #24a66a);
}

.tournamentEventsModern__athletes > i.is-unlimited > b {
  background: var(--blue-500, #3298cc);
}

.tournamentEventsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover > td {
  background: #f8fbfd;
}

.tournamentEventsModern .table-responsive table.table-hover tbody tr.table-primary > td {
  background: #eef6fc !important;
}

/* Shared shell for the active school-side tournament sub-lists. */
.tournamentEventsModern,
.tournamentTeamsModern,
.tournamentTeamPlayersModern {
  min-height: calc(100vh - 76px);
  margin-top: -20px;
  padding: 0 12px 28px;
  background: var(--surface-page, #f8fafc);
}

.tournamentListPageHeader {
  display: flex;
  min-height: 76px;
  align-items: center;
  gap: 14px;
  margin: 0 -42px 14px -34px;
  padding: 12px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.tournamentListPageHeader > button {
  display: inline-flex;
  min-height: 32px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--blue-700, #155d8c);
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentListPageHeader > button:hover,
.tournamentListPageHeader > button:focus-visible {
  background: var(--blue-50, #eef6fc);
  outline: none;
}

.tournamentListPageHeader > i {
  width: 1px;
  height: 34px;
  flex: 0 0 1px;
  background: var(--border-default, #cbd5e1);
}

.tournamentListPageHeader > div {
  min-width: 0;
}

.tournamentListPageHeader small {
  display: block;
  overflow: hidden;
  margin-bottom: 2px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 650;
  line-height: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tournamentListPageHeader h1 {
  overflow: hidden;
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  line-height: 28px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tournamentListPageHeader > b {
  display: inline-flex;
  min-width: 26px;
  min-height: 24px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
}

.tournamentEventsModern .gridModernRoot,
.tournamentTeamsModern .gridModernRoot,
.tournamentTeamPlayersModern .gridModernRoot,
.tournamentInvitesManagePage .gridModernRoot {
  width: 100%;
  min-width: 0;
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.tournamentEventsModern .gridPanelTitleRow,
.tournamentTeamsModern .gridPanelTitleRow,
.tournamentTeamPlayersModern .gridPanelTitleRow,
.tournamentInvitesManagePage .gridPanelTitleRow {
  min-height: 66px;
  margin: 0;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.tournamentEventsModern .gridPanelTitle > h1,
.tournamentTeamsModern .gridPanelTitle > h1,
.tournamentTeamPlayersModern .gridPanelTitle > h1,
.tournamentInvitesManagePage .gridPanelTitle > h1,
.tournamentEventsModern .gridPanelTitle > h1 + span,
.tournamentTeamsModern .gridPanelTitle > h1 + span,
.tournamentTeamPlayersModern .gridPanelTitle > h1 + span,
.tournamentInvitesManagePage .gridPanelTitle > h1 + span {
  display: none;
}

.tournamentEventsModern .gridModernPagination,
.tournamentTeamsModern .gridModernPagination,
.tournamentTeamPlayersModern .gridModernPagination,
.tournamentInvitesManagePage .gridModernPagination {
  min-height: 58px;
  margin: 0;
  padding: 10px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

@media (max-width: 760px) {
  .tournamentEventsModern,
  .tournamentTeamsModern,
  .tournamentTeamPlayersModern,
  .tournamentInvitesManagePage {
    padding: 0 8px 22px;
  }

  .tournamentListPageHeader {
    min-height: 72px;
    margin-right: -38px;
    margin-left: -30px;
    padding-right: 16px;
    padding-left: 16px;
  }

  .tournamentListPageHeader > i {
    display: none;
  }

  .tournamentListPageHeader > button {
    padding-right: 4px;
    padding-left: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Tournaments/TournamentEvents.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;EAIE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,mDAAmD;EACnD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;EACnD,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE;;;IAGE,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,8CAA8C;EAChD;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,mEAAmE;AACrE;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,yEAAyE;EACzE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,MAAM;IACN,OAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;;;;;IAOE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,mDAAmD;EACnD,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kEAAkE;AAClE;;;EAGE,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE;;;;IAIE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".mTournamentEditPlayersFormWidth {\n  max-width: 1020px !important;\n  width: min(1020px, calc(100vw - 32px)) !important;\n}\n\n.tournamentManageEventsModal {\n  overflow: hidden;\n  border-radius: 14px !important;\n}\n\n.tournamentManageEventsModal__body {\n  padding: 0 !important;\n}\n\n.ttm-page .ttm-edit-btn {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #d8e2ec;\n  border-radius: 6px;\n  background: #fff;\n  color: #5b6b7a;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  padding: 0;\n}\n\n.ttm-page .ttm-edit-btn:hover {\n  background: #f4f8fc;\n  border-color: #b8cde3;\n  color: #2f80ed;\n}\n\n.ttm-page .ttm-edit-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(47, 128, 237, 0.15);\n}\n\n.ttm-page table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.ttm-page th,\n.ttm-page td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ttm-page th:last-child,\n.ttm-page td:last-child {\n  width: 52px;\n  min-width: 52px;\n  max-width: 52px;\n  text-align: center;\n}\n\n.ttm-page th:nth-child(1),\n.ttm-page td:nth-child(1) {\n  width: 26%;\n}\n\n.ttm-page th:nth-child(2),\n.ttm-page td:nth-child(2) {\n  width: 24%;\n}\n\n.ttm-page th:nth-child(3),\n.ttm-page td:nth-child(3) {\n  width: 20%;\n}\n\n.ttm-page th:nth-child(4),\n.ttm-page td:nth-child(4) {\n  width: 18%;\n}\n\n.ttm-page th:nth-child(5),\n.ttm-page td:nth-child(5) {\n  width: 12%;\n}\n\n.tournamentTeamConflictModal .modal-body {\n  padding: 0;\n}\n\n.tournamentTeamConflictModal__body {\n  padding: 20px 22px;\n}\n\n.tournamentTeamConflictModal__intro {\n  margin: 0 0 16px;\n  color: var(--text-muted, #69778a);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.tournamentTeamConflictModal__list {\n  display: grid;\n  gap: 10px;\n}\n\n.tournamentTeamConflictModal__row {\n  padding: 13px 14px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--surface-subtle, #f8fafc);\n}\n\n.tournamentTeamConflictModal__row > strong {\n  display: block;\n  margin-bottom: 9px;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n}\n\n.tournamentTeamConflictModal__choices {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.tournamentTeamConflictModal__choices label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 9px 10px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.tournamentTeamConflictModal__choices label:has(input:checked) {\n  border-color: var(--blue-500, #3298cc);\n  background: var(--blue-50, #eef8fc);\n}\n\n.tournamentTeamConflictModal__choices input {\n  accent-color: var(--blue-600, #227ebd);\n}\n\n.tournamentTeamConflictModal__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.tournamentTeamConflictModal__actions button {\n  height: 36px;\n  padding: 0 15px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentTeamConflictModal__actions button:last-child {\n  border-color: var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n@media (max-width: 640px) {\n  .tournamentTeamConflictModal__choices {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tournamentEventsModern,\n.tournamentTeamsModern,\n.tournamentTeamPlayersModern,\n.tournamentInvitesManagePage {\n  min-width: 0;\n  padding: 20px 12px 28px;\n  background: #f7f8fa;\n}\n\n.tournamentInvitesManagePage > .row,\n.tournamentInvitesManagePage > .row > [class*='col-'] {\n  margin: 0;\n  padding: 0;\n}\n\n.tournamentTeamPlayersModern {\n  min-height: calc(100vh - 76px);\n  margin-top: -20px;\n  padding: 0 12px 28px;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.tournamentTeamPlayersModern__header,\n.tournamentTeamPlayersModern__card,\n.tournamentTeamPlayersModern__footer,\n.tournamentTeamPlayersModern__error {\n  width: 100%;\n}\n\n.tournamentTeamPlayersModern__header {\n  box-sizing: border-box;\n  width: auto;\n  margin: 0 -36px 18px;\n  padding: 15px 28px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.tournamentTeamPlayersModern__back {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 10px;\n  padding: 0 8px;\n  border-radius: 8px;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentTeamPlayersModern__back:hover {\n  background: var(--blue-50, #eef6fc);\n}\n\n.tournamentTeamPlayersModern__headingRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.tournamentTeamPlayersModern__eyebrow {\n  display: block;\n  margin-bottom: 3px;\n  color: var(--blue-700, #155d8c);\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.tournamentTeamPlayersModern__headingRow h1 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 850;\n  line-height: 1.2;\n}\n\n.tournamentTeamPlayersModern__headingRow p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n\n.tournamentTeamPlayersModern__summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  flex: 0 1 auto;\n}\n\n.tournamentTeamPlayersModern__summary span {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 10px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  font-weight: 650;\n}\n\n.tournamentTeamPlayersModern__identity {\n  min-width: 0;\n  flex: 1 1 480px;\n}\n\n.tournamentTeamPlayersModern__contextTitle {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 550;\n  line-height: 1.35;\n}\n\n.tournamentTeamPlayersModern__contextTitle strong {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.tournamentTeamPlayersModern__teamDetails {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.tournamentTeamPlayersModern__teamDetails > img,\n.tournamentTeamPlayersModern__schoolInitial {\n  display: inline-flex;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 17px;\n  font-weight: 800;\n  object-fit: contain;\n}\n\n.tournamentTeamPlayersModern__teamDetails > div,\n.tournamentTeamPlayersModern__teamDetails strong,\n.tournamentTeamPlayersModern__teamDetails div > span {\n  display: block;\n}\n\n.tournamentTeamPlayersModern__teamDetails strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.tournamentTeamPlayersModern__teamDetails div > span {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.tournamentTeamPlayersModern__summary span.is-available {\n  border-color: #cde8d7;\n  background: #edf8f1;\n  color: #287a50;\n}\n\n.tournamentTeamPlayersModern__summary span.is-available strong {\n  color: inherit;\n}\n\n.tournamentTeamPlayersModern__summary strong {\n  color: var(--text-strong, #142033);\n}\n\n.tournamentTeamPlayersModern__summary span.is-over-limit {\n  border-color: var(--red-300, #fca5a5);\n  background: var(--red-50, #fff1f2);\n  color: var(--red-700, #b42318);\n}\n\n.tournamentTeamPlayersModern__summary span.is-over-limit strong {\n  color: var(--red-800, #991b1b);\n}\n\n.tournamentTeamPlayersModern__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 14px;\n  padding: 10px 12px 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 0;\n  background: transparent;\n}\n\n.tournamentTeamPlayersModern__toolbarActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tournamentTeamPlayersModern__toolbarActions button {\n  display: inline-flex;\n  min-height: 34px;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.tournamentTeamPlayersModern__toolbarActions button:hover {\n  border-color: var(--blue-400, #55a8d5);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.tournamentTeamPlayersModern__toolbarActions button:disabled {\n  cursor: not-allowed;\n  opacity: 0.48;\n}\n\n.tournamentPlayerNumberModal .modal-body {\n  padding: 0;\n}\n\n.tournamentPlayerNumberForm {\n  padding: 2px 20px 18px;\n}\n\n.tournamentPlayerNumberForm__person {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 10px;\n  border-radius: 10px;\n  background: var(--surface-sunken, #f1f5f9);\n}\n\n.tournamentPlayerNumberForm__person > span {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.tournamentPlayerNumberForm__person strong,\n.tournamentPlayerNumberForm__person small {\n  display: block;\n}\n\n.tournamentPlayerNumberForm__person strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n}\n\n.tournamentPlayerNumberForm__person small {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n\n.tournamentPlayerNumberForm > label > span {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.tournamentPlayerNumberForm > label input {\n  width: 140px;\n  height: 38px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: 0;\n  font-size: 13px;\n}\n\n.tournamentPlayerNumberForm > label input:focus {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n\n.tournamentPlayerNumberForm > label > small {\n  display: block;\n  margin-top: 6px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n\n.tournamentPlayerNumberForm__error {\n  margin-top: 10px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 12px;\n}\n\n.tournamentPlayerNumberForm footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.tournamentPlayerNumberForm footer button {\n  min-height: 36px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentPlayerNumberForm footer .is-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.tournamentTeamNumbersModal .modal-body {\n  padding: 0;\n}\n.tournamentTeamNumbersForm {\n  padding: 2px 20px 18px;\n}\n.tournamentTeamNumbersForm > p {\n  margin: 0 0 16px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n.tournamentTeamNumbersForm > p strong {\n  color: var(--text-strong, #0f172a);\n}\n.tournamentTeamNumbersForm__range {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n.tournamentTeamNumbersForm__range label {\n  margin: 0;\n}\n.tournamentTeamNumbersForm__range label > span,\n.tournamentTeamNumbersForm legend {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 750;\n}\n.tournamentTeamNumbersForm__range b {\n  color: #dc2626;\n}\n.tournamentTeamNumbersForm__range input {\n  width: 128px;\n  height: 38px;\n  padding: 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: 0;\n  font-size: 13px;\n}\n.tournamentTeamNumbersForm__range input:focus {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n.tournamentTeamNumbersForm fieldset {\n  margin: 18px 0 0;\n  padding: 0;\n  border: 0;\n}\n.tournamentTeamNumbersForm__option {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0 0 8px;\n  padding: 10px 11px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 9px;\n  cursor: pointer;\n}\n.tournamentTeamNumbersForm__option input {\n  margin-top: 3px;\n  accent-color: var(--blue-500, #227ebd);\n}\n.tournamentTeamNumbersForm__option span,\n.tournamentTeamNumbersForm__option strong,\n.tournamentTeamNumbersForm__option small {\n  display: block;\n}\n.tournamentTeamNumbersForm__option strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n}\n.tournamentTeamNumbersForm__option small {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n.tournamentTeamNumbersForm__error {\n  margin-top: 10px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 12px;\n}\n.tournamentTeamNumbersForm footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n.tournamentTeamNumbersForm footer button {\n  min-height: 36px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  font-weight: 700;\n}\n.tournamentTeamNumbersForm footer .is-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.tournamentTeamPlayersModern__card {\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n}\n\n.tournamentTeamPlayersModern__cardHead {\n  padding: 0 0 11px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.tournamentTeamPlayersModern__cardHead h2 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 15.5px;\n  font-weight: 750;\n}\n\n.tournamentTeamPlayersModern__cardHead p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n\n.tournamentTeamPlayersModern__editor {\n  min-width: 0;\n  padding-top: 12px;\n}\n\n.tournamentTeamPlayersModern__error {\n  margin-top: 12px;\n  padding: 11px 13px;\n  border: 1px solid #ffd5da;\n  border-radius: 9px;\n  background: #fff5f6;\n  color: var(--red-700, #9f2430);\n  font-size: 12.5px;\n  font-weight: 650;\n}\n\n.tournamentTeamPlayersModern__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 16px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n}\n\n.tournamentTeamPlayersModern__footer > div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.tournamentTeamPlayersModern__footer strong {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n}\n\n.tournamentTeamPlayersModern__footer span {\n  color: var(--amber-700, #9a6500);\n  font-size: 11.5px;\n  font-weight: 650;\n}\n\n.tournamentTeamPlayersModern__footer button {\n  display: inline-flex;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.tournamentTeamPlayersModern__footer button.isSecondary {\n  border: 1px solid var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-body, #334155);\n}\n\n.tournamentTeamPlayersModern__footer button.isPrimary {\n  min-width: 156px;\n  border: 1px solid var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n.tournamentTeamPlayersModern__footer button.isPrimary:disabled {\n  border-color: var(--slate-300, #cbd5e1);\n  background: var(--slate-300, #cbd5e1);\n  cursor: not-allowed;\n}\n\n.tournamentTeamPlayersModern__footer svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.9;\n}\n\n.tournamentParticipantsExitModalHost {\n  padding: 0 !important;\n}\n\n.tournamentParticipantsNoticeModalHost {\n  padding: 0 !important;\n}\n\n.tournamentParticipantsNoticeModal {\n  overflow: hidden;\n  border-radius: 14px;\n  background: #fff;\n}\n\n.tournamentParticipantsNoticeModal > header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.tournamentParticipantsNoticeModal__icon {\n  display: inline-flex;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--blue-500, #227ebd);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.tournamentParticipantsNoticeModal.isWarning .tournamentParticipantsNoticeModal__icon {\n  background: var(--amber-500, #d99a19);\n}\n\n.tournamentParticipantsNoticeModal header > div:nth-child(2) {\n  flex: 1 1 auto;\n}\n.tournamentParticipantsNoticeModal h2 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 18px;\n  font-weight: 800;\n}\n.tournamentParticipantsNoticeModal header p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n.tournamentParticipantsNoticeModal header > button {\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  font-size: 22px;\n  line-height: 1;\n}\n.tournamentParticipantsNoticeModal__body {\n  padding: 20px 22px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  line-height: 1.55;\n  white-space: pre-wrap;\n}\n.tournamentParticipantsNoticeModal > footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--surface-subtle, #f8fafc);\n}\n.tournamentParticipantsNoticeModal footer button {\n  min-height: 38px;\n  padding: 0 16px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.tournamentParticipantsExitModal {\n  overflow: hidden;\n  border-radius: 14px;\n  background: #fff;\n}\n\n.tournamentParticipantsExitModal > header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.tournamentParticipantsExitModal h2 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.tournamentParticipantsExitModal header p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n\n.tournamentParticipantsExitModal header > button {\n  width: 30px;\n  height: 30px;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  font-size: 22px;\n  line-height: 1;\n}\n\n.tournamentParticipantsExitModal__body {\n  padding: 20px 22px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.tournamentParticipantsExitModal > footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--surface-subtle, #f8fafc);\n}\n\n.tournamentParticipantsExitModal footer button {\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.tournamentParticipantsExitModal footer button.isDanger {\n  border-color: var(--red-600, #c4313f);\n  background: var(--red-600, #c4313f);\n  color: #fff;\n}\n\n@media (max-width: 760px) {\n  .tournamentTeamPlayersModern__headingRow,\n  .tournamentTeamPlayersModern__toolbar,\n  .tournamentTeamPlayersModern__footer {\n    align-items: stretch;\n    flex-direction: column;\n    position: sticky;\n    bottom: 8px;\n    z-index: 10;\n    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14);\n  }\n\n  .tournamentTeamPlayersModern__summary,\n  .tournamentTeamPlayersModern__toolbarActions,\n  .tournamentTeamPlayersModern__footer > div {\n    justify-content: flex-start;\n  }\n\n  .tournamentTeamPlayersModern__footer > div:last-child button {\n    flex: 1 1 0;\n  }\n}\n\n.tournamentTeamsModern {\n  min-height: calc(100vh - 76px);\n  color: #334155;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.tournamentTeamsModern > .row,\n.tournamentTeamsModern > .row > [class*='col-'] {\n  margin: 0;\n  padding: 0;\n}\n\n.tournamentTeamsModern .gridPanelTitleRow {\n  margin: 0 0 16px;\n}\n\n.tournamentTeamsModern .gridPanelTitle {\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.tournamentTeamsModern .gridModernTitleBlock {\n  min-width: min(100%, 280px);\n  margin-right: 4px;\n}\n\n.tournamentTeamsModern .gridModernTitleBlock h1 {\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  line-height: 30px;\n  font-weight: 850;\n}\n\n.tournamentTeamsModern .gridModernBack {\n  margin-bottom: 2px;\n}\n\n.tournamentTeamsModern .gridModernSearch {\n  width: min(260px, 100%);\n  margin-left: 0;\n}\n\n.tournamentTeamsModern .gridInlineActions button {\n  border-color: #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n\n.tournamentTeamsModern .gridInlineActions {\n  margin-left: auto;\n}\n\n.tournamentTeamsModern .gridTableActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  margin: 12px 0 8px;\n  padding: 9px 11px;\n  border: 1px solid #cfe1f2;\n  border-radius: 10px;\n  background: #f3f8fc;\n}\n\n.tournamentTeamsModern .gridTableActions > span {\n  flex: 0 0 auto;\n  color: #456b84;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.tournamentTeamsModern .gridTableActions > div {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 7px;\n}\n\n.tournamentTeamsModern .gridTableActions button {\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid #b8cad8;\n  border-radius: 8px;\n  background: #fff;\n  color: #27536f;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentTeamsModern .gridTableActions button:hover {\n  border-color: #7eabc7;\n  background: #f8fcff;\n}\n\n.tournamentTeamsModern .gridTableActions button.is-danger {\n  border-color: var(--red-500, #c4313f);\n  background: var(--red-500, #c4313f);\n  color: #fff;\n}\n\n.tournamentTeamsModern .gridTableActions button.is-danger:hover {\n  border-color: var(--red-600, #a92734);\n  background: var(--red-600, #a92734);\n}\n\n.tournamentTeamsModern .gridInlineActions button:hover {\n  border-color: #8ab8d5;\n  background: #f3f8fc;\n  color: #176895;\n}\n\n.tournamentTeamsModern .gridInlineActions button:only-child:not(.is-danger) {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.tournamentTeamsModern .gridInlineActions button:only-child:not(.is-danger):hover {\n  border-color: #196b9f;\n  background: #196b9f;\n}\n\n.tournamentTeamsModern .table-responsive {\n  margin-top: 0;\n  overflow-x: auto;\n  border: 1px solid #dbe3ec;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.tournamentTeamsModern table.table {\n  min-width: 680px;\n  margin: 0 !important;\n  table-layout: fixed;\n}\n\n.tournamentTeamsModern table thead th {\n  padding: 12px 14px;\n  border: 0;\n  border-bottom: 1px solid #dbe3ec;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n.tournamentTeamsModern table thead th:first-child,\n.tournamentTeamsModern table tbody td:first-child {\n  width: 48px;\n  text-align: center;\n}\n\n.tournamentTeamsModern table tbody td {\n  height: 56px;\n  padding: 12px 14px;\n  border: 0;\n  border-bottom: 1px solid #edf1f5;\n  background: #fff;\n  color: #334155;\n  font-size: 13px;\n  line-height: 19px;\n  vertical-align: middle;\n}\n\n.tournamentTeamsModern table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr > td,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover > td,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary > td,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary:hover,\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary:hover > td {\n  transform: none;\n  box-shadow: none;\n}\n\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover > td {\n  background: #f8fbfd;\n}\n\n.tournamentTeamsModern .table-responsive table.table-hover tbody tr.table-primary > td {\n  background: #eef6fc !important;\n}\n\n.tournamentTeamsModern__cell--name {\n  color: #172033 !important;\n  font-weight: 750;\n}\n\n.tournamentTeamsModern__cell--numberOfStudents {\n  color: #475569 !important;\n  font-variant-numeric: tabular-nums;\n}\n\n.tournamentTeamsModern .gridModernEmptyRow:hover > td,\n.tournamentTeamsModern .gridModernEmptyRow > td {\n  height: 190px;\n  background: #fff !important;\n  text-align: center;\n  cursor: default;\n}\n\n.tournamentTeamsModern .gridModernEmptyRow td > span,\n.tournamentTeamsModern .gridModernEmptyRow td > strong,\n.tournamentTeamsModern .gridModernEmptyRow td > small {\n  display: block;\n}\n\n.tournamentTeamsModern .gridModernEmptyRow td > span {\n  margin-bottom: 8px;\n  color: #94a3b8;\n  font-size: 26px;\n}\n\n.tournamentTeamsModern .gridModernEmptyRow td > strong {\n  color: #334155;\n  font-size: 14px;\n}\n\n.tournamentTeamsModern .gridModernEmptyRow td > small {\n  margin-top: 4px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.tournamentTeamsModern .gridModernPagination {\n  justify-content: flex-end;\n  padding-top: 14px;\n}\n\n.tournamentEventsModern .gridModernFilterPopover {\n  position: fixed;\n  z-index: 1060;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  max-height: none;\n  flex-direction: column;\n  overflow: hidden;\n  border: 0;\n  border-left: 1px solid #dbe3ec;\n  border-radius: 0;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.tournamentEventsModern .gridModernFilterPopover__fields {\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-y: auto;\n}\n\n@media (max-width: 600px) {\n  .tournamentEventsModern,\n  .tournamentTeamsModern,\n  .tournamentTeamPlayersModern {\n    padding: 14px;\n  }\n\n  .tournamentEventsModern .gridModernFilterPopover {\n    top: 0;\n    left: 0;\n    width: 100vw;\n    max-width: none;\n    height: 100vh;\n  }\n\n  .tournamentTeamsModern .gridPanelTitle {\n    align-items: stretch;\n  }\n\n  .tournamentTeamsModern .gridModernTitleBlock,\n  .tournamentTeamsModern .gridModernSearch,\n  .tournamentTeamsModern .gridModernFiltersAnchor,\n  .tournamentTeamsModern .gridModernFilterButton,\n  .tournamentTeamsModern .gridModernColumns,\n  .tournamentTeamsModern .gridModernColumns > button,\n  .tournamentTeamsModern .gridInlineActions {\n    width: 100%;\n  }\n\n  .tournamentTeamsModern .gridInlineActions {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .tournamentTeamsModern .gridTableActions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .tournamentTeamsModern .gridTableActions > div {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .tournamentTeamsModern .gridModernFilterPopover {\n    position: fixed;\n    inset: 0;\n    width: 100vw;\n    max-width: none;\n    border-radius: 0;\n  }\n}\n\n.tournamentEventParticipants {\n  min-width: 0;\n  padding: 0;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.tournamentEventParticipants__header .bSchoolTeamManager__summaryCard {\n  margin: 0;\n  padding: 18px 22px 14px;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #e5e9f0);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n}\n\n.tournamentEventParticipants__title {\n  margin: 0 0 4px;\n  color: var(--text-strong, #0f172a);\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.tournamentEventParticipants__header .bSchoolTeamManager__summaryTitle {\n  margin-top: 3px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 500;\n}\n\n.tournamentEventParticipants__header .bSchoolTeamManager__summaryText {\n  display: none;\n}\n\n.tournamentEventParticipants__header .tournamentEventParticipants__close {\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 8px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 18px;\n}\n\n.tournamentEventParticipants--loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: min(1100px, calc(100vw - 48px));\n  min-height: 560px;\n  background: var(--surface-card, #fff);\n}\n\n.tournamentEventParticipants__limitWarning {\n  margin: 14px 22px 0;\n  padding: 12px 14px;\n  color: #721c24;\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-left: 5px solid #dc3545;\n  border-radius: 6px;\n}\n\n.tournamentEventParticipants__limitWarning p {\n  margin: 2px 0 6px;\n}\n\n.tournamentEventParticipants__editor {\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n}\n\n.tournamentEventParticipants__editor .twoPanelEditor__row {\n  margin: 0;\n}\n\n.tournamentEventParticipants__studentName {\n  display: flex;\n  min-width: 150px;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.tournamentEventParticipants__studentName small {\n  max-width: 260px;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  white-space: normal;\n}\n\n.tournamentEventParticipants__footer {\n  margin: 0;\n  padding: 13px 22px;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #e5e9f0);\n  border-radius: 0;\n  background: var(--surface-card, #fff);\n}\n\n.tournamentEventParticipants__footer .bSchoolTeamManager__btnSecondary,\n.tournamentEventParticipants__footer .bSchoolTeamManager__btnPrimary {\n  min-height: 40px;\n  padding: 0 18px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.tournamentEventsModern > .row,\n.tournamentEventsModern > .row > [class*='col-'] {\n  margin: 0;\n  padding: 0;\n}\n\n.tournamentEventsModern .gridPanelTitleRow {\n  margin: 0 0 16px;\n}\n\n.tournamentEventsModern .gridPanelTitle {\n  display: grid;\n  grid-template-columns: minmax(240px, 360px) auto auto 1fr;\n  gap: 10px;\n}\n\n.tournamentEventsModern .gridModernTitleLine h1 {\n  color: var(--text-strong, #0f172a);\n  font-size: 24px;\n  font-weight: 800;\n}\n\n.tournamentEventsModern .gridModernTitleBlock {\n  grid-column: 1 / -1;\n}\n\n.tournamentEventsModern .gridModernSearch {\n  width: min(100%, 360px);\n  margin: 0;\n}\n\n.tournamentEventsModern .gridInlineActions {\n  grid-column: 1 / -1;\n  margin: 0;\n}\n\n.tournamentEventsModern .gridInlineActions button,\n.tournamentEventsModern .gridTableActions button {\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.tournamentEventsModern .gridInlineActions button:first-child:not(:disabled),\n.tournamentEventsModern .gridTableActions button:first-child:not(:disabled) {\n  border-color: var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n.tournamentEventsModern .gridTableActions {\n  display: flex;\n  min-height: 0;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  margin: 0 0 12px;\n  padding: 8px 14px;\n  border: 1px solid var(--blue-100, #d4e8f6);\n  border-radius: 8px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.tournamentEventsModern .gridActiveFilters + .gridTableActions {\n  margin-top: 10px;\n}\n\n.tournamentEventsModern .gridTableActions > span {\n  flex: 0 0 auto;\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.tournamentEventsModern .gridTableActions > div {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tournamentEventsModern .gridTableActions button {\n  min-height: 32px;\n  height: 32px;\n  padding: 0 11px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.tournamentEventsModern .table-responsive {\n  overflow-x: auto;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.tournamentEventsModern table.table {\n  margin: 0 !important;\n}\n\n.tournamentEventsModern table thead th {\n  border-top: 0;\n  background: var(--surface-subtle, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.tournamentEventsModern table tbody td {\n  padding: 12px 14px;\n  border-top: 0;\n  border-bottom: 1px solid #edf1f5;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  line-height: 1.4;\n  vertical-align: middle;\n}\n\n.tournamentEventsModern table tbody td a {\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.tournamentEventsModern .gridModernSearch input {\n  font-size: 13px;\n}\n\n.tournamentEventsModern .gridModernSearch__clear {\n  position: relative;\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  flex: 0 0 26px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 0;\n  cursor: pointer;\n}\n\n.tournamentEventsModern .gridModernSearch__clear::before,\n.tournamentEventsModern .gridModernSearch__clear::after {\n  position: absolute;\n  width: 12px;\n  height: 1.5px;\n  border-radius: 999px;\n  background: currentColor;\n  content: '';\n}\n\n.tournamentEventsModern .gridModernSearch__clear::before {\n  transform: rotate(45deg);\n}\n\n.tournamentEventsModern .gridModernSearch__clear::after {\n  transform: rotate(-45deg);\n}\n\n.tournamentEventsModern .gridModernSearch__clear:hover {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.tournamentEventsModern .gridModernSearch__clear:focus-visible {\n  outline: 2px solid var(--blue-500, #227ebd);\n  outline-offset: 1px;\n}\n\n.tournamentEventsModern .gridModernBack,\n.tournamentEventsModern .gridModernFilterButton,\n.tournamentEventsModern .gridModernColumns > button {\n  font-size: 13px;\n}\n\n.tournamentEventParticipants,\n.tournamentEventParticipants button,\n.tournamentEventParticipants input,\n.tournamentEventParticipants select {\n  font-size: 13px;\n}\n\n.tournamentEventParticipants .twoPanelEditorPanel__personText strong {\n  font-size: 13px;\n}\n\n.tournamentEventParticipants .twoPanelEditorPanel__personText small,\n.tournamentEventParticipants .twoPanelEditorPanel__modernTitle span,\n.tournamentEventParticipants .twoPanelEditorPanel__capacity > span {\n  font-size: 11px;\n}\n\n.tournamentEventsModern__cell--generatedName {\n  color: var(--blue-700, #1c5d8c) !important;\n  font-weight: 650;\n}\n\n.tournamentEventsModern__cell--status {\n  width: 110px;\n  color: var(--green-700, #1c7a44) !important;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.tournamentEventsModern__status {\n  display: inline-flex;\n  min-height: 22px;\n  align-items: center;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #536273;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.tournamentEventsModern__status.is-accepted,\n.tournamentEventsModern__status.is-approved {\n  background: #e4f5ea;\n  color: #1c7a44;\n}\n\n.tournamentEventsModern__status.is-pending,\n.tournamentEventsModern__status.is-not-ready {\n  background: #fdf1dc;\n  color: #a86b08;\n}\n\n.tournamentEventsModern__athletes span,\n.tournamentEventsModern__athletes small {\n  display: block;\n}\n\n.tournamentEventsModern__athletes span {\n  overflow: hidden;\n  color: var(--text-body, #334155);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tournamentEventsModern__athletes small {\n  margin-top: 3px;\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n}\n\n.tournamentEventsModern__athletes > i {\n  display: block;\n  width: 64px;\n  height: 4px;\n  margin-top: 4px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #edf1f5;\n}\n\n.tournamentEventsModern__athletes > i > b {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--green-500, #24a66a);\n}\n\n.tournamentEventsModern__athletes > i.is-unlimited > b {\n  background: var(--blue-500, #3298cc);\n}\n\n.tournamentEventsModern .table-responsive table.table-hover tbody tr:not(.table-primary):hover > td {\n  background: #f8fbfd;\n}\n\n.tournamentEventsModern .table-responsive table.table-hover tbody tr.table-primary > td {\n  background: #eef6fc !important;\n}\n\n/* Shared shell for the active school-side tournament sub-lists. */\n.tournamentEventsModern,\n.tournamentTeamsModern,\n.tournamentTeamPlayersModern {\n  min-height: calc(100vh - 76px);\n  margin-top: -20px;\n  padding: 0 12px 28px;\n  background: var(--surface-page, #f8fafc);\n}\n\n.tournamentListPageHeader {\n  display: flex;\n  min-height: 76px;\n  align-items: center;\n  gap: 14px;\n  margin: 0 -42px 14px -34px;\n  padding: 12px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.tournamentListPageHeader > button {\n  display: inline-flex;\n  min-height: 32px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 6px;\n  padding: 0 8px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  cursor: pointer;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentListPageHeader > button:hover,\n.tournamentListPageHeader > button:focus-visible {\n  background: var(--blue-50, #eef6fc);\n  outline: none;\n}\n\n.tournamentListPageHeader > i {\n  width: 1px;\n  height: 34px;\n  flex: 0 0 1px;\n  background: var(--border-default, #cbd5e1);\n}\n\n.tournamentListPageHeader > div {\n  min-width: 0;\n}\n\n.tournamentListPageHeader small {\n  display: block;\n  overflow: hidden;\n  margin-bottom: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 15px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tournamentListPageHeader h1 {\n  overflow: hidden;\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 28px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tournamentListPageHeader > b {\n  display: inline-flex;\n  min-width: 26px;\n  min-height: 24px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.tournamentEventsModern .gridModernRoot,\n.tournamentTeamsModern .gridModernRoot,\n.tournamentTeamPlayersModern .gridModernRoot,\n.tournamentInvitesManagePage .gridModernRoot {\n  width: 100%;\n  min-width: 0;\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));\n}\n\n.tournamentEventsModern .gridPanelTitleRow,\n.tournamentTeamsModern .gridPanelTitleRow,\n.tournamentTeamPlayersModern .gridPanelTitleRow,\n.tournamentInvitesManagePage .gridPanelTitleRow {\n  min-height: 66px;\n  margin: 0;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.tournamentEventsModern .gridPanelTitle > h1,\n.tournamentTeamsModern .gridPanelTitle > h1,\n.tournamentTeamPlayersModern .gridPanelTitle > h1,\n.tournamentInvitesManagePage .gridPanelTitle > h1,\n.tournamentEventsModern .gridPanelTitle > h1 + span,\n.tournamentTeamsModern .gridPanelTitle > h1 + span,\n.tournamentTeamPlayersModern .gridPanelTitle > h1 + span,\n.tournamentInvitesManagePage .gridPanelTitle > h1 + span {\n  display: none;\n}\n\n.tournamentEventsModern .gridModernPagination,\n.tournamentTeamsModern .gridModernPagination,\n.tournamentTeamPlayersModern .gridModernPagination,\n.tournamentInvitesManagePage .gridModernPagination {\n  min-height: 58px;\n  margin: 0;\n  padding: 10px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n@media (max-width: 760px) {\n  .tournamentEventsModern,\n  .tournamentTeamsModern,\n  .tournamentTeamPlayersModern,\n  .tournamentInvitesManagePage {\n    padding: 0 8px 22px;\n  }\n\n  .tournamentListPageHeader {\n    min-height: 72px;\n    margin-right: -38px;\n    margin-left: -30px;\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .tournamentListPageHeader > i {\n    display: none;\n  }\n\n  .tournamentListPageHeader > button {\n    padding-right: 4px;\n    padding-left: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
